import React from 'react'

const DIDACT_ID = 1
const EDUCA_ID = 2
const LITERARY_ID = 3
const DIGITAL_ID = 8
const BILINGUE_ID = 9
const RELIGION_ID = 13

export function getDeliveryIntroText(is_immediate, school_is_b2c, isSingleBook) {
  if (is_immediate) {
    return (
      <p>Os livros ficarão disponíveis para <span className="yellow-text">retirada na escola</span>.</p>
    )
  }
  if (school_is_b2c) {
    return (
      <p>Os livros serão entregues no <span className="yellow-text">endereço informado no cadastro</span>{isSingleBook ? '' : <>, podendo chegar em <strong>datas distintas</strong></>}.</p>
    )
  }
  return (
    <p>Os livros serão <span className="yellow-text">entregues na escola</span> conforme data estabelecida{isSingleBook ? '.' : <>, podendo chegar em <strong>datas distintas</strong>:</>}</p>
  )
}

export function getDeliveryCards(businessLines, is_immediate, school_is_b2c, educaDeliveryType) {
  const cards = []
  const hasLine = id => businessLines.includes(id)

  if (hasLine(DIDACT_ID)) cards.push({ key: 'did', title: 'Didáticos', subtitle: null })
  if (hasLine(BILINGUE_ID)) cards.push({ key: 'bil', title: 'Bilingue', subtitle: null })

  if (hasLine(LITERARY_ID)) {
    cards.push({
      key: 'lit',
      title: 'Literatura Infanto Juvenil',
      subtitle: 'Pode ser entregue após os demais produtos.',
    })
  }

  if (hasLine(EDUCA_ID)) {
    cards.push({
      key: 'edu',
      title: 'Soluções Educacionais',
      subtitle: is_immediate ? null : educaDeliveryType && educaDeliveryType.startsWith('anual') ? 'Entrega Anual' : 'Entrega Semestral',
    })
  }

  if (hasLine(DIGITAL_ID)) {
    cards.push({ key: 'dig', title: 'Livros Digitais', subtitle: 'Chave de acesso será encaminhada por email.' })
  }

  if (hasLine(RELIGION_ID)) {
    cards.push({ key: 'ere', title: 'Ensino Religioso', subtitle: null })
  }

  return cards
}

export function getDeliveryEstimateCard(is_immediate, school_is_b2c, cutDateActive, deliveryEstimateValue) {
  if (is_immediate) {
    return (
      <div className="delivery-estimate-card">
        <span><strong>Estimativa de entrega na escola:</strong> em 48 horas ou de acordo com orientação da escola</span>
        <span className="text-red">*</span>
      </div>
    )
  }
  if (!school_is_b2c && cutDateActive) {
    return (
      <div className="delivery-estimate-card delivery-estimate-card--date">
        <span className="delivery-estimate-card__label">Estimativa de entrega na escola</span>{' '}
        <strong className="delivery-estimate-card__value">{deliveryEstimateValue} <span className="text-red">*</span></strong>
      </div>
    )
  }
  return (
    <div className="delivery-estimate-card">
      <span><strong>Estimativa de entrega:</strong> em até 20 dias úteis após a confirmação do pagamento</span>
      <span className="text-red">*</span>
    </div>
  )
}
